module.exports = __webpack_public_path__ + "static/media/IMG_20190818_184054.8a4b8c4c.jpg";